<template>
  <div>
    <div
      v-if="layanan"
      class="row"
    >
      <div
        class="col-md-6"
        v-for="p in layanan"
        :key="p.id_layanan"
      >
        <div
          class="layanan-item card"
          @click="lihatLayanan(p)"
        >
          <div class="card-body">
            <div class="d-flex">
              <div class="layanan-icon mr-3 text-center">
                <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+p.icon">
              </div>
              <div style="width: 70%">
                <h6>{{ p.nama_layanan }}</h6>
              </div>
              <div style="margin-left:auto">
                <b-button
                  variant="primary"
                  title="Lihat Syarat"
                >
                  <i class="fa fa-eye" />
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isBisaTambahLayanan"
        class="col-md-6"
        @click="$bvModal.show('modal-tambah-layanan')"
      >
        <div class="layanan-item card">
          <div class="card-body">
            <p class="text-center">
              <i class="fa fa-plus mr-2" />
              Tambah Layanan
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div
        class="col-md-6"
        v-for="i in 4"
        :key="i"
      >
        <div class="layanan-item card">
          <div class="card-body">
            <div class="d-flex">
              <div class="layanan-icon mr-3 text-center">
                <div class="content-loader" />
              </div>
              <div style="width: 70%">
                <h6 class="content-loader">
                  Nama Layanan
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-lihat-layanan"
      size="lg"
    >
      <template #modal-title>
        <div
          v-if="layananSelected"
          class="d-flex"
        >
          <div class="layanan-icon mr-3 text-center">
            <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+layananSelected.icon">
          </div>
          <div v-if="layananSelected.paket_layanan">
            <h5 class="mb-1">
              {{ layananSelected.nama_layanan }}
            </h5>
            <small class="text-muted">{{ layananSelected.paket_layanan.paket.nama_paket }}</small>
          </div>
        </div>
      </template>
      <div v-if="layananSelected">
        <h6 class="mt-4">
          <i
            class="fa fa-user text-primary"
            style="width:1.5rem"
          />Data Layanan
        </h6>
        <div class="pl-4">
          <p v-if="layananSelected.paket_layanan">
            <b>Petunjuk</b><br>
            Petunjuk lengkap tentang pengajuan {{ layananSelected.nama_layanan }} dapat didownload dengan menekan tombol berikut:
            <br>
            <a
              v-if="layananSelected.paket_layanan"
              class="btn btn-sm btn-primary text-white"
              :href="$store.getters.getBaseUrl+'/api/file/'+layananSelected.paket_layanan.file_petunjuk"
            ><i class="fa fa-download mr-2" />Download Petunjuk</a>
          </p>
          <p v-if="layananSelected.paket_layanan">
            <b>Dokumen Persyaratan</b><br>
            {{ layananSelected.paket_layanan.text_persyaratan }}
          </p>
          <p v-if="layananSelected.paket_layanan">
            <b>Pengambilan Dokumen Kependudukan</b><br>
            {{ layananSelected.paket_layanan.text_ambil_dok }}
          </p>
        </div>

        <h6 class="mt-3">
          <i
            class="fas fa-upload text-primary"
            style="width:1.5rem"
          />Dokumen Persyaratan
        </h6>
        <div class="pl-4">
          <table class="table table-sm">
            <tr
              v-for="(s, i) in layananSelected.layanan_dokumen"
              :key="s.id_layanan_dokumen"
            >
              <td>{{ i+1 }}</td>
              <td>
                {{ s.dokumen.nama_dokumen }} <i
                  class="text-danger"
                  v-if="s.is_harus_diisi"
                >*)</i> <i v-if="s.keterangan">({{ s.keterangan }})</i>
              </td>
              <td
                v-if="s.dokumen.kode_dokumen"
                style="min-width:130px"
              >
                <a
                  :href="$store.getters.getBaseUrl+'/uploads/form/'+s.dokumen.file"
                  target="_blank"
                  class="btn btn-primary btn-sm"
                  :title="'Download Template '+s.dokumen.nama_dokumen"
                ><i class="fa fa-download mr-2" />Form</a>
                <a
                  v-if="s.contoh_form"
                  :href="$store.getters.getBaseUrl+'/api/file/'+s.contoh_form"
                  target="_blank"
                  class="btn btn-success btn-sm"
                  :title="'Download Contoh '+s.dokumen.nama_dokumen"
                ><i class="fa fa-download mr-2" />Contoh</a>
              </td>
              <td v-else />
            </tr>
          </table>
          <p><i><span class="text-danger">*)</span> dokumen wajib</i></p>
        </div>
                
        <h6 class="mt-3">
          <i
            class="fas fa-clock text-primary"
            style="width:1.5rem"
          />Waktu Pengerjaan
        </h6>
        <div class="pl-4">
          <table
            class="table table-sm"
            v-if="layananSelected.paket_layanan"
          >
            <tr v-if="layananSelected.paket_layanan.is_valid_desa">
              <td><b>Validasi Tingkat Desa</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_desa >= 24) ? layananSelected.paket_layanan.std_mutu_desa/24 + ' hari' : layananSelected.paket_layanan.std_mutu_desa + ' jam' }}</td>
            </tr>
            <tr v-if="layananSelected.paket_layanan.is_valid_kecamatan">
              <td><b>Validasi Tingkat Kecamatan</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_kecamatan >= 24) ? layananSelected.paket_layanan.std_mutu_kecamatan/24 + ' hari' : layananSelected.paket_layanan.std_mutu_kecamatan + ' jam' }}</td>
            </tr>
            <tr v-if="layananSelected.paket_layanan.is_valid_dukcapil">
              <td><b>Validasi Tingkat Dukcapil</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_dukcapil >= 24) ? layananSelected.paket_layanan.std_mutu_dukcapil/24 + ' hari' : layananSelected.paket_layanan.std_mutu_dukcapil + ' jam' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- <h6 class="mt-4"><i class="fa fa-list-ol text-primary" style="width:1.5rem"></i>Mekanisme Permohonan</h6>
            <div class="pl-4">
            </div> -->
      <template #modal-footer>
        <b-button
          variant="danger"
          @click="$bvModal.hide('modal-lihat-layanan')"
        >
          <i class="fa fa-times mr-2" /> Batal
        </b-button>
        <b-button
          variant="primary"
          @click="pilihLayanan($event)"
        >
          <i class="fa fa-check mr-2" /> Buat Permohonan
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-tambah-layanan"
      title="Tambah Layanan"
      hide-footer
      size="lg"
    >
      <div class="text-center">
        <img
          :src="$store.getters.getBaseUrl+'/api/file/'+selectedPaket.icon"
          width="100"
        >
        <br>
        <div class="form-group row mt-3">
          <label
            for=""
            class="col-form-label col-lg-3"
          >Nama Layanan</label>
          <div class="col-lg-9">
            <input
              type="text"
              class="form-control"
              v-model="formTambahLayanan.nama_layanan"
            >
          </div>
        </div>

        <div class="text-right mt-3">
          <button
            id="btnSimpanTambahLayanan"
            class="btn btn-primary"
            @click="submitTambahLayanan"
          >
            <i class="fa fa-check mr-2" />Tambah Layanan
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>

 
</style>

<script>
import swal from 'sweetalert'

export default {
    data() {
        return {
            formTambahLayanan: {
                nama_layanan: '',
                id_paket: ''
            }
        }
    },
    computed: {
        layanan: {
            get(){
                return this.$store.getters.getLayanan
            },
            set(newVal){

            }
        },
        layananSelected(){
            return this.$store.getters.getLayananSelected
        },
        selectedPaket(){
            return this.$store.getters.getSelectedPaket
        },
        namaRole(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        },
        isBisaTambahLayanan(){
            let bisaTambah = false
            if(this.mode === 'info'){
                if(
                    this.namaRole === 'Admin Laksita' ||
                    this.namaRole === 'Admin Jembrana' || 
                    this.namaRole === 'Operator Dukcapil'){
                    bisaTambah = true
                }
            }
            if (this.dataLayanan){
                bisaTambah = false
            }
            return bisaTambah
        }
    },
    props: ['mode', 'type', 'dataLayanan'],
    methods: {
        pilihLayanan(e){
            swal({
                title: "Konfirmasi",
                text: `Buat Permohonan ${this.layananSelected.nama_layanan}?`,
                icon: "warning",
                buttons: {
                    cancel: "Batal",
                    ok: {
                        text: "Ya",
                        value: "ok",
                    },
                }
            }).then(val => {
                if(val === 'ok'){

                    let button = e.target
                    let buttonHtml = button.innerHTML

                    button.setAttribute('disabled', true)
                    button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Buat Permohonan'


                    /**
                     * Fungsi ini untuk mengecek apakah sudah mengajukan layanan ini.
                     * Khusus untuk rumah sakit, tidak perlu ditanya.
                     */
                    let role = this.$store.getters.getAuthService.currentRole.nama_role
                    if (['Penduduk', 'Operator Desa'].includes(role)) {
                      let dispatchPermohonan = 'Penduduk' // defaultnya penduduk

                      if(role === 'Penduduk'){
                          dispatchPermohonan = 'fetchPermohonanPenduduk'
                      } else if(role === 'Operator Desa'){
                          dispatchPermohonan = 'fetchPermohonanDesa'
                      }
                      this.$store.dispatch(dispatchPermohonan).then(res => {
                          let permohonanPenduduk = res.data.data

                          let permohonanExist = false

                          if(role === 'Penduduk'){
                              permohonanPenduduk.forEach(e => {
                                  if(e.id_paket_layanan === this.layananSelected.paket_layanan.id_paket_layanan){
                                      permohonanExist = true
                                  }
                              })
                          } else if(role === 'Operator Desa'){
                              let pendudukBantu = this.$store.getters.getPendudukBantu
                              // console.log(pendudukBantu)
                              // TODO: jangan di foreach. pakai filter kek, find kek.
                              permohonanPenduduk.forEach(e => {
                                  if(e.id_paket_layanan === this.layananSelected.paket_layanan.id_paket_layanan && e.id_penduduk === pendudukBantu.id_penduduk){
                                      permohonanExist = true
                                  }
                              })
                          }

                          

                          if(!permohonanExist){
                              // jika belum ada, insert biasa
                              this.insertPermohonan(button, buttonHtml) // biar buttonnya loading

                          } else {
                              // jika sudah ada, munculkan peringatan

                              swal({
                                  title: "Informasi",
                                  text: `Anda sebelumnya sudah membuat permohonan ${this.layananSelected.nama_layanan}. Apakah ingin membuat lagi?`,
                                  icon: "warning",
                                  buttons: {
                                      cancel: "Tidak",
                                      ok: {
                                          text: "Iya",
                                          value: "ok",
                                      },
                                  }
                              }).then( val => {
                                  if(val === 'ok'){
                                      this.insertPermohonan(button, buttonHtml)
                                  } else {
                                      button.removeAttribute('disabled')
                                      button.innerHTML = buttonHtml
                                  }
                              })
                          }
                      })
                      return false
                      // end cek pernah insert permohonan
                    }
                    this.insertPermohonan(button, buttonHtml) // biar buttonnya loading
                }
            })
        },
        insertPermohonan(button, buttonHtml){
            let role = this.$store.getters.getAuthService.currentRole.nama_role

            let dispatchPermohonan = 'storePermohonanPenduduk'

            let formData = new FormData()
            formData.append('id_paket_layanan', this.layananSelected.paket_layanan.id_paket_layanan) 


            if(role === 'Penduduk'){
                dispatchPermohonan = 'storePermohonanPenduduk'
            } else if(role === 'Operator Desa'){
                dispatchPermohonan = 'storePermohonanPendudukByDesa'
                formData.append('id_penduduk', this.$store.getters.getPendudukBantu.id_penduduk)
            } else if (role === 'Rumah Sakit') {
                dispatchPermohonan = 'storePermohonanPendudukByRumahSakit'
                formData.append('id_penduduk', this.$store.getters.getPendudukBantu.id_penduduk)
            }
                      
            this.$store.dispatch(dispatchPermohonan, formData).then(res => {
                // console.log(res)
                if(res.data.status){
                    swal({
                        title: "Berhasil",
                        text: res.data.message,
                        icon: "success",
                        buttons: "Ok"
                    }).then(val => {
                        this.$bvModal.hide('modal-lihat-layanan')
                        this.$store.dispatch('setDataPermohonan', res.data.data)
                    })
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            }).catch(err => {
                // console.log('err', err)
                // console.log('err.response', err.response)
                switch(err.response.status){
                    case 500:
                        this.$router.push({path: '/500'})
                        break;

                    case 400:
                        swal({
                            title: "Gagal",
                            text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                    
                    default:
                        swal({
                            title: "Gagal",
                            text: err.response.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                        break;
                }
                
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
            })
        },
        lihatLayanan(data){
            // console.log(data)
            let showLayanan = data
            // showLayanan.paket_layanan = showLayanan.paket_layanan[0]
            this.$store.dispatch('selectLayanan', showLayanan)

            if(this.mode === 'buat-permohonan'){
                this.$bvModal.show('modal-lihat-layanan')
            } else if(this.mode === 'info'){
                if(this.type === 'public'){
                    this.$router.push({path: `/layanan/${this.selectedPaket.slug}/${data.slug}`})
                } else {
                    this.$router.push({path: `/info-layanan/${this.selectedPaket.slug}/${data.slug}`})
                }
                
            }
        },
        submitTambahLayanan(){
            swal({
                title: "Konfirmasi",
                text: "Yakin ingin menambah layanan?",
                icon: "warning",
                buttons: {
                    cancel: "Batal",
                    ok: {
                        text: "Yakin, tambah",
                        value: "ok",
                    },
                }
            }).then( val => {
                if(val === 'ok'){
                    let button = document.querySelector('#btnSimpanTambahLayanan')
                    let buttonHtml = button.innerHTML
                    
                    button.setAttribute('disabled', true)
                    button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Upload'

                    let formData = new FormData()
                    formData.append('nama_layanan', this.formTambahLayanan.nama_layanan)
                    formData.append('id_paket', this.selectedPaket.id_paket)

                    this.$store.dispatch('storeLayanan', formData).then(res => {
                        button.removeAttribute('disabled')
                        button.innerHTML = buttonHtml
                        if(res.data.status){
                            swal({
                                title: "Berhasil",
                                text: res.data.message,
                                icon: "success",
                                buttons: {
                                    ok: {
                                        text: "Ok",
                                        value: "ok",
                                    },
                                }
                            }).then( val => {
                                if(val === 'ok'){
                                    window.location = ''
                                }
                            })
                        }
                    })
                }
            })
        }
    },
    created(){
        if(!this.dataLayanan){
            this.$store.dispatch('emptyLayanan')
            if(this.selectedPaket){
                this.$store.dispatch('fetchLayananByPaket', this.selectedPaket)
            }

            if(this.type === 'public'){
                this.$store.dispatch('fetchLayananByPaketPublic', this.$route.params.slugpaket).then(res => {
                    if(res.data.status){
                        this.$store.dispatch('setLayanan', res.data.data)
                        this.$store.dispatch('selectPaket', res.data.data[0].paket_layanan[0].paket)
                    } else {
                        swal({
                            title: "Gagal",
                            text: res.data.message,
                            icon: "error",
                            buttons: "Ok"
                        })
                    }
                }).catch(err => {
                    // console.log(err)
                    switch(err.response.status){
                        case 500:
                            this.$router.push({path: '/500'})
                            break;

                        case 400:
                            swal({
                                title: "Gagal",
                                text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                                icon: "error",
                                buttons: "Ok"
                            })
                            break;
                        
                        default:
                            swal({
                                title: "Gagal",
                                text: err.response.data.message,
                                icon: "error",
                                buttons: "Ok"
                            })
                            break;
                    }
                })
            }
        }
    },
    watch: {
        selectedPaket(newVal){
            if(this.type === 'public'){
                //
            } else {
                this.$store.dispatch('fetchLayananByPaket', newVal)
            }
            
        }
    }
}
</script>